import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { endpoints } from '../../core/constants/endpoints';
import {
  IQuickActionsResponse,
  IQuickActionsResponseRaw,
  toQuickActionsResponse
} from '../interfaces/quick-action.interface';

@Injectable({ providedIn: 'root' })
export class QuickActionsApi {
  private cache$: Observable<IQuickActionsResponse> | null = null;

  constructor(private http: HttpClient) {}

  getQuickActions(): Observable<IQuickActionsResponse> {
    if (!this.cache$) {
      this.cache$ = this.http
        .get<IQuickActionsResponseRaw>(
          `${environment.ceppemAiApi}/${endpoints.ceppemAi.quickActions}`
        )
        .pipe(
          map(toQuickActionsResponse),
          shareReplay(1),
          catchError(err => {
            this.cache$ = null;
            return throwError(err);
          })
        );
    }
    return this.cache$;
  }

  clearCache(): void {
    this.cache$ = null;
  }
}
